import React from 'react';

import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { IBaseProps } from '@rbi-ctg/frontend';
import useMediaQuery, { MediaQuery } from 'hooks/use-media-query';
import { useUIContext } from 'state/ui';
import { isItemPickerOrComboRoute } from 'utils/routing';

const Container = styled.div<{ $bottomInset: number }>`
  display: flex;
  flex-direction: column;
  position: fixed;
  bottom: ${p => p.$bottomInset}px;
  width: 100%;
  z-index: ${Styles.zIndex.overlay};
  ${Styles.mobile`
    bottom: calc(${(p: { $bottomInset: number }) =>
      p.$bottomInset}px + env(safe-area-inset-bottom));
  `}
`;

const LayoutBottomContainer: React.FC<IBaseProps> = ({ children }) => {
  const { appFooterDimensions } = useUIContext();
  const { pathname } = useLocation();
  const isDesktop = useMediaQuery(MediaQuery.Desktop);

  return (
    <Container
      $bottomInset={
        isItemPickerOrComboRoute(pathname) && !isDesktop ? 85 : appFooterDimensions.height
      }
    >
      {children}
    </Container>
  );
};

export default LayoutBottomContainer;
